/**
 * @fileoverview GET handler for the "/engagement/in_app_message_color_profiles/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementInAppMessageColorProfilesTags } from "./constants";
import type { EngagementInAppMessageColorProfilesTagsResult } from "./types";

export const getEngagementInAppMessageColorProfilesTags = reactQueryFetcherAdapter(
  engagementInAppMessageColorProfilesTags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementInAppMessageColorProfilesTagsResult> => {
    return fetch("/engagement/in_app_message_color_profiles/tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
